export const EVENTS = {
    CLICK: 'click',
    CHANGE: 'change',
    SCROLL: 'scroll',
    POINTER_DOWN: 'pointerdown',
    POINTER_MOVE: 'pointermove',
    POINTER_UP: 'pointerup',
    POINTER_CANCEL: 'pointercancel',
};

export const ATTRIBUTES = {
    ACTIVE_TAB: 'active-tab',
    USE_HISTORY: 'use-history',
    DISABLE_TAB_BAR_SCROLL: 'disable-tab-bar-scroll',
};

/** Drag past this distance (px) treats the gesture as a scroll drag and suppresses the next tab click. */
export const DRAG_CLICK_SUPPRESS_PX = 8;

/** Applied to the tab bar row when `scrollWidth` exceeds the visible width; enables drag and grab cursor. */
export const TAB_BAR_OVERFLOW_CLASS = 'tabs--overflow';

/** Applied to the tab bar container while the user is pointer-dragging to scroll. */
export const TAB_BAR_DRAGGING_CLASS = 'is-dragging';

/** Sub-pixel tolerance when comparing `scrollWidth` to `clientWidth`. */
export const TAB_BAR_OVERFLOW_EPSILON_PX = 1;

/** Debounce for recomputing tab bar overflow after resize (window / ResizeObserver). */
export const TAB_BAR_OVERFLOW_SYNC_DEBOUNCE_MS = 100;
